import { render, staticRenderFns } from "./RangoFechas.vue?vue&type=template&id=47b2a15e&"
import script from "./RangoFechas.vue?vue&type=script&lang=js&"
export * from "./RangoFechas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports